import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { StyledUILink } from '../../styles/TextInput.styles';
export const HaveAnAccountLink = ({
  href,
  accountLinkMessage = 'button.haveAnAccountLink',
  onClick = () => {}
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: accountLinkMessage
    }), /*#__PURE__*/_jsx(StyledUILink, {
      href: href,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: 'button.signIn'
      })
    })]
  });
};